import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AppExpert, useApp } from './context/AppContext';
import { Navbar, ToastContainer } from './components/UI';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import ExpertDashboard from './pages/ExpertDashboard';
import ExpertProfile from './pages/ExpertProfile';
import ExpertServices from './pages/ExpertServices';
import LearnerProfile from './pages/LearnerProfile';
import { LearnerDashboard, VideoSession, AdminPanel } from './pages/LearnerAndAdmin';
import TutorPayment from './pages/TutorPayment';
import AdminLogin from './pages/AdminLogin';
import PaymentReturn from './pages/PaymentReturn';
import './index.css';

function ProtectedRoute({ children, requiredRole }) {
  const { user } = useApp();
  if (!user) return <Navigate to="/auth?mode=login" replace />;
  if (requiredRole) {
    const isLearnerRoute = requiredRole === 'receiver' || requiredRole === 'learner';
    const userIsLearner  = user.role === 'receiver' || user.role === 'learner';
    // Deny wrong role in both directions — previously experts could slip through to /learner
    if (isLearnerRoute && !userIsLearner) return <Navigate to="/" replace />;
    if (!isLearnerRoute && user.role !== requiredRole) return <Navigate to="/" replace />;
  }
  return children;
}

function RoleBasedHome() {
  const { user } = useApp();
  if (user?.role === 'expert') return <Navigate to="/expert" replace />;
  return <Landing />;
}

function AppRoutes() {
  const location = useLocation();
  const hideNavbar = location.pathname === '/admin' || location.pathname === '/payment-return';

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/"           element={<RoleBasedHome />} />
        <Route path="/auth"       element={<Auth />} />
        <Route path="/expert/:id" element={<ExpertProfile />} />
        <Route path="/expert/:id/services" element={<ExpertServices />} />
        <Route path="/expert"   element={<ProtectedRoute requiredRole="expert"><ExpertDashboard /></ProtectedRoute>} />
        <Route path="/learner"    element={<ProtectedRoute requiredRole="receiver"><LearnerDashboard /></ProtectedRoute>} />
        <Route path="/learner/profile" element={<ProtectedRoute requiredRole="receiver"><LearnerProfile /></ProtectedRoute>} />
        <Route path="/admin"      element={<AdminLogin />} />
        <Route path="/session/:id" element={<ProtectedRoute><VideoSession /></ProtectedRoute>} />
        <Route path="/tutor/payment" element={<TutorPayment />} />
        <Route path="/payment-return" element={<PaymentReturn />} />
        <Route path="*"           element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default function App() {
  return (
    <AppExpert>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppExpert>
  );
}
